// Pick-a-hero roster (Radville's pick-a-survivor model). Slugs are ~/Projects/meshy-chars folders;
// tools/build-art.py builds client/public/art/char-<slug>.png for each.
export const HEROES: { slug: string; name: string }[] = [
  { slug: 'dungeon_rogue', name: 'Rogue' },
  { slug: 'dw_battle_cleric', name: 'Battle Cleric' },
  { slug: 'dw_dwarven_miner', name: 'Dwarven Miner' },
  { slug: 'dw_witch_hunter', name: 'Witch Hunter' },
  { slug: 'celtic_celtic_hunter', name: 'Hunter' },
  { slug: 'celtic_druid_knight', name: 'Druid Knight' },
  { slug: 'celtic_forest_warden', name: 'Forest Warden' },
  { slug: 'celtic_wild_hunter', name: 'Wild Hunter' },
  { slug: 'celtic_horned_warrior', name: 'Horned Warrior' },
  { slug: 'celtic_blood_druid', name: 'Blood Druid' },
  { slug: 'celtic_mist_witch', name: 'Mist Witch' },
  { slug: 'dw_vampire_duelist', name: 'Duelist' },
];
export const isHero = (v: unknown): v is string => typeof v === 'string' && HEROES.some((h) => h.slug === v);
